module.exports = "<div class=\"browser-warning\" translate> \n  This PBX is not activated.\n</div>";